// extracted by mini-css-extract-plugin
module.exports = {"spacer":"V_dv","title":"V_J"};